export default {
    customerHasSelected: state => state.customerList.filter(customer => customer.status == true).length > 0,
    customerList: state => state.customerList,
    customerData: state => state.customerData,
    customerInfo: state => state.customerInfo,
    customerHistory: state => state.customerHistory,
    customerHistoryData: state => state.customerHistoryData,
    tempCustomer: state => state.tempCustomer,
    groupList: state => state.groupList,
    groupData: state => state.groupData,
    groupMember: state => state.groupMember,
    groupInfo: state => state.groupInfo,
    chartInfo: state => state.chartInfo,
    deleteGroupMember: state => state.deleteGroupMember,
    deleteGroupInfo: state => state.deleteGroupInfo,
    customerGroup: state => state.customerGroup,
    customerCallingInfo: state => state.customerCallingInfo,
    smsCallTemplate: state => state.smsCallTemplate
}
